(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[13971,93812,15282],{

/***/ 93812:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_Illustration; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var node_modules_classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(node_modules_classnames);
// EXTERNAL MODULE: ./UI/components/Illustration/utils/helpers.js
var helpers = __webpack_require__(45783);
// EXTERNAL MODULE: ./UI/components/Illustration/styles.module.scss
var styles_module = __webpack_require__(31890);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./UI/components/Illustration/utils/useIllustration.js





/* harmony default export */ function useIllustration(_param) {
    var src = _param.src, isStatic = _param.isStatic, classnames = _param.className, _lazyBoundary = _param.lazyBoundary, lazyBoundary = _lazyBoundary === void 0 ? "700px" : _lazyBoundary, apiParams = _param.apiParams, transparent = _param.transparent, placeholderProp = _param.placeholder, priority = _param.priority, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "src",
        "isStatic",
        "className",
        "lazyBoundary",
        "apiParams",
        "transparent",
        "placeholder",
        "priority"
    ]);
    var loader = isStatic ? function(param) {
        var staticSrc = param.src;
        return staticSrc;
    } : function(args) {
        return (0,helpers/* getContentfulImage */.t)((0,_object_spread/* default */.Z)({
            transparent: transparent
        }, args, apiParams));
    };
    var className = classnames_default()((styles_module_default()).image, classnames);
    var lazyProps = !priority ? {
        placeholder: placeholderProp || (transparent ? "blur" : "empty"),
        blurDataURL: (0,helpers/* getContentfulImage */.t)({
            src: src,
            quality: 1,
            format: "webp",
            transparent: transparent
        })
    } : {};
    return (0,_object_spread/* default */.Z)({
        src: src,
        loader: loader,
        className: className,
        lazyBoundary: lazyBoundary,
        priority: priority
    }, lazyProps, rest);
};

;// CONCATENATED MODULE: ./UI/components/Illustration/index.jsx








var Illustration = /*#__PURE__*/ (0,react.memo)(function(props) {
    var _ref = useIllustration(props), className = _ref.className, style = _ref.style, containerClasses = _ref.containerClasses, restProps = (0,_object_without_properties/* default */.Z)(_ref, [
        "className",
        "style",
        "containerClasses"
    ]);
    if (!(restProps === null || restProps === void 0 ? void 0 : restProps.src) || restProps.placeholder === "blur" && !restProps.blurDataURL) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("picture", {
        className: classnames_default()(className, containerClasses),
        style: style,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), (0,_object_spread/* default */.Z)({}, restProps))
    });
});
Illustration.defaultProps = {
    layout: "fill",
    alt: "",
    transparent: false,
    apiParams: {}
};
Illustration.propTypes = {
    transparent: (prop_types_default()).bool,
    // For more props check https://nextjs.org/docs/api-reference/next/legacy/image
    src: (prop_types_default()).string.isRequired,
    alt: (prop_types_default()).string,
    layout: prop_types_default().oneOf([
        "fill",
        "intrinsic",
        "fixed",
        "responsive", 
    ]),
    placeholder: prop_types_default().oneOf([
        "blur",
        "empty", 
    ]),
    // Check https://www.contentful.com/developers/docs/references/images-api/ for detailed api
    apiParams: prop_types_default().instanceOf(Object)
};
/* harmony default export */ var components_Illustration = (Illustration);


/***/ }),

/***/ 84860:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_Selector; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 15 modules
var swiper_react = __webpack_require__(30719);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.min.css
var swiper_min = __webpack_require__(30933);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./UI/components/Selector/utils/useSelector.js

var useSelector = function(param) {
    var view = param.view, type = param.type, displayNames = param.displayNames, selectedIndex = param.selectedIndex, onSelectedIndexChange = param.onSelectedIndexChange;
    var handleSelectedIndexChange = (0,react.useCallback)(function(i) {
        return function() {
            return onSelectedIndexChange(i);
        };
    }, [
        onSelectedIndexChange
    ]);
    return {
        view: view,
        type: type,
        displayNames: displayNames,
        selectedIndex: selectedIndex,
        handleSelectedIndexChange: handleSelectedIndexChange
    };
};

// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 92 modules
var swiper_esm = __webpack_require__(44040);
;// CONCATENATED MODULE: ./UI/components/Selector/utils/helpers.js

var SELECTOR_SWIPER_PARAMS = {
    cssMode: true,
    enabled: true,
    slidesPerView: "auto",
    passiveListeners: true,
    freeMode: true,
    mousewheel: {
        forceToAxis: true
    },
    autoplay: {
        delay: 800,
        disableOnInteraction: false
    },
    speed: 500,
    spaceBetween: 24,
    modules: [
        swiper_esm/* FreeMode */.Rv
    ],
    breakpoints: {
        768: {
            spaceBetween: 48
        }
    }
};

// EXTERNAL MODULE: ./UI/components/Selector/styles.module.scss
var styles_module = __webpack_require__(94481);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./UI/components/Selector/index.jsx










var Selector = function(props) {
    var ref = useSelector(props), view = ref.view, type = ref.type, displayNames = ref.displayNames, selectedIndex = ref.selectedIndex, handleSelectedIndexChange = ref.handleSelectedIndexChange;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((styles_module_default()).wrapper, (styles_module_default())[type], (styles_module_default())[view]),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, SELECTOR_SWIPER_PARAMS), {
                children: displayNames === null || displayNames === void 0 ? void 0 : displayNames.map(function(name, i) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                        className: classnames_default()((styles_module_default()).item, (0,_define_property/* default */.Z)({}, (styles_module_default()).selected, i === selectedIndex)),
                        onClick: handleSelectedIndexChange(i),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: name
                        })
                    }, name);
                })
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (styles_module_default()).itemsContainer,
                children: displayNames === null || displayNames === void 0 ? void 0 : displayNames.map(function(name, i) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        role: "tab",
                        tabIndex: 0,
                        className: classnames_default()((styles_module_default()).item, (0,_define_property/* default */.Z)({}, (styles_module_default()).selected, i === selectedIndex)),
                        onClick: handleSelectedIndexChange(i),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: name
                        })
                    }, name);
                })
            })
        ]
    });
};
/* harmony default export */ var components_Selector = (Selector);


/***/ }),

/***/ 35565:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ containers_CardContainer; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./UI/containers/CardContainer/CardContainer.module.scss
var CardContainer_module = __webpack_require__(14910);
var CardContainer_module_default = /*#__PURE__*/__webpack_require__.n(CardContainer_module);
;// CONCATENATED MODULE: ./UI/containers/CardContainer/utils/useCardContainer.js





/* harmony default export */ function useCardContainer(_param) {
    var children = _param.children, classes = _param.className, noBackground = _param.noBackground, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "className",
        "noBackground"
    ]);
    var className = classnames_default()((CardContainer_module_default()).cardContainer, classes, (0,_define_property/* default */.Z)({}, (CardContainer_module_default()).noBackground, noBackground));
    return (0,_object_spread/* default */.Z)({
        children: children,
        className: className
    }, rest);
};

;// CONCATENATED MODULE: ./UI/containers/CardContainer/index.jsx







var CardContainer = function(props, ref) {
    var _ref = useCardContainer(props), children = _ref.children, className = _ref.className, restProps = (0,_object_without_properties/* default */.Z)(_ref, [
        "children",
        "className"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: className,
        ref: ref
    }, restProps), {
        children: children
    }));
};
CardContainer.propTypes = {
    children: (prop_types_default()).node.isRequired,
    noBackground: (prop_types_default()).bool,
    className: (prop_types_default()).string
};
/* harmony default export */ var containers_CardContainer = (/*#__PURE__*/(0,react.forwardRef)(CardContainer));


/***/ }),

/***/ 76974:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ sections_TabsSection; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./UI/containers/CardContainer/index.jsx + 1 modules
var CardContainer = __webpack_require__(35565);
// EXTERNAL MODULE: ./UI/components/SectionTitle/index.jsx
var SectionTitle = __webpack_require__(15805);
// EXTERNAL MODULE: ./UI/components/Selector/index.jsx + 2 modules
var Selector = __webpack_require__(84860);
// EXTERNAL MODULE: ./utils/constants.js
var constants = __webpack_require__(96076);
// EXTERNAL MODULE: ./UI/components/Illustration/index.jsx + 1 modules
var Illustration = __webpack_require__(93812);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(6572);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
;// CONCATENATED MODULE: ./UI/sections/TabsSection/utils/getTabBlocks.js



/* harmony default export */ function getTabBlocks() {
    var data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return data === null || data === void 0 ? void 0 : data.map(function(tabSection) {
        var ref = (0,helper/* getDocumentFields */.OA)(tabSection, [
            "title",
            "contentModules", 
        ]), tabTitle = ref.title, contentModules = ref.contentModules;
        var texts = contentModules === null || contentModules === void 0 ? void 0 : contentModules.map(function(param) {
            var fields = param.fields;
            return fields.text;
        });
        var content = contentModules === null || contentModules === void 0 ? void 0 : contentModules.map(function(module) {
            var ref = (0,helper/* getDocumentFields */.OA)(module, [
                "text",
                "images",
                "imagesBundles",
                "contentModules", 
            ]), text = ref.text, images = ref.images, bundles = ref.imagesBundles, extraModule = ref.contentModules;
            var ref1 = (0,_sliced_to_array/* default */.Z)((images || []).map(helper/* getImage */.gJ), 1), imageUrl = ref1[0];
            var imagesBundles = (bundles || []).map(helper/* getImage */.gJ);
            var ref2 = (0,helper/* getDocumentFields */.OA)(get_default()(extraModule, "[0]"), [
                "url"
            ]), prototypeUrl = ref2.url;
            return {
                text: text,
                imageUrl: imageUrl,
                prototypeUrl: prototypeUrl,
                imagesBundles: imagesBundles
            };
        });
        var link = contentModules === null || contentModules === void 0 ? void 0 : contentModules.find(function(item) {
            return item.sys.contentType.sys.id === "link";
        });
        return {
            tabTitle: tabTitle,
            texts: texts,
            content: content,
            link: link
        };
    });
};

;// CONCATENATED MODULE: ./UI/sections/TabsSection/utils/useSectionProps.js




/* harmony default export */ function useSectionProps(param) {
    var section = param.section, type = param.type, handleOnCTAClick = param.handleOnCTAClick, data = param.data;
    var ref = (0,helper/* getDocumentFields */.OA)(section || data, [
        "title",
        "description",
        "contentModules",
        "view", 
    ], {
        isNormilized: data && !Object.keys(data).includes("fields") || section && !Object.keys(section).includes("fields")
    }), title = ref.title, view = ref.view, description = ref.description, contentModules = ref.contentModules;
    var ref1 = (0,react.useState)(0), activeTab = ref1[0], setActiveTab = ref1[1];
    var tabList = (0,helper/* getDocumentFields */.OA)(get_default()(contentModules, "[0]", [
        "contentModules",
        "tabsHaveContentInBlocks"
    ]));
    var tabs;
    if (tabList.tabsHaveContentInBlocks) {
        tabs = getTabBlocks(tabList.contentModules);
    } else {
        tabs = tabList.contentModules.map(function(el, i) {
            return (0,helper/* getDocumentFields */.OA)(get_default()(tabList.contentModules, "[".concat(i, "]"), [
                "title",
                "text"
            ]));
        });
    }
    var displayNames = tabList.contentModules.map(function(el, i) {
        return (0,helper/* getDocumentFields */.OA)(get_default()(tabList.contentModules, "[".concat(i, "]"), [
            "title",
            "text"
        ])).title;
    });
    var linkAfterBlock = get_default()(contentModules, "[1]", null);
    return {
        onChangeActiveTab: setActiveTab,
        handleOnCTAClick: handleOnCTAClick,
        tabs: tabs,
        activeTab: activeTab,
        title: title,
        description: description,
        view: view,
        type: type,
        displayNames: displayNames,
        linkAfterBlock: linkAfterBlock,
        tabsHaveContentInBlocks: tabList.tabsHaveContentInBlocks
    };
};

// EXTERNAL MODULE: ./UI/sections/TabsSection/styles.module.scss
var styles_module = __webpack_require__(69977);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./UI/sections/TabsSection/index.jsx














var ContentfulParser = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 92870));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(92870)
            ];
        }
    }
});
var CallToAction = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 35767).then(__webpack_require__.bind(__webpack_require__, 49617));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(49617)
            ];
        }
    }
});
var Animated = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 61971).then(__webpack_require__.bind(__webpack_require__, 61971));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(61971)
            ];
        }
    }
});
var FigmaPrototype = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 32293).then(__webpack_require__.bind(__webpack_require__, 32293));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(32293)
            ];
        }
    },
    ssr: false
});
var TabsSection = function(props) {
    var ref = useSectionProps(props), onChangeActiveTab = ref.onChangeActiveTab, handleOnCTAClick = ref.handleOnCTAClick, tabs = ref.tabs, activeTab = ref.activeTab, title = ref.title, description = ref.description, view = ref.view, type = ref.type, displayNames = ref.displayNames, linkAfterBlock = ref.linkAfterBlock, tabsHaveContentInBlocks = ref.tabsHaveContentInBlocks;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: classnames_default()((styles_module_default()).section, (styles_module_default())[type], (styles_module_default())[view]),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (styles_module_default()).container,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionTitle["default"], {
                    title: title,
                    description: description,
                    titleStyle: (styles_module_default()).titleStyle
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Selector["default"], {
                    view: view,
                    type: type,
                    displayNames: displayNames,
                    selectedIndex: activeTab,
                    onSelectedIndexChange: onChangeActiveTab
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContainer/* default */.Z, {
                    className: (styles_module_default()).cardContainer,
                    children: tabs.map(function(param, index) {
                        var text = param.text, link = param.link, content = param.content;
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                            className: classnames_default()((styles_module_default()).cardWrapper, (styles_module_default())["cardWrapper-".concat(index + 1)], (0,_define_property/* default */.Z)({}, (styles_module_default()).cardWrapperActive, index === activeTab)),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Animated, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, constants/* REVEAL_ANIMATION_PROPS */.kt), {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: classnames_default()((styles_module_default()).cardContent, (styles_module_default())["cardContent-".concat(index + 1)]),
                                        children: tabsHaveContentInBlocks ? content === null || content === void 0 ? void 0 : content.map(function(param, i) {
                                            var blockText = param.text, imageUrl = param.imageUrl, prototypeUrl = param.prototypeUrl, imagesBundles = param.imagesBundles;
                                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                                className: classnames_default()((styles_module_default()).contentBlock, (styles_module_default())["contentBlock-".concat(i + 1)]),
                                                children: [
                                                    imageUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)(Illustration["default"], {
                                                        priority: true,
                                                        unoptimized: true,
                                                        src: imageUrl.url,
                                                        className: (styles_module_default()).blockImage,
                                                        alt: imageUrl.alt
                                                    }),
                                                    prototypeUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)(FigmaPrototype, {
                                                        src: prototypeUrl,
                                                        className: (styles_module_default()).blockPrototype
                                                    }),
                                                    blockText && /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentfulParser, {
                                                        document: blockText
                                                    }),
                                                    imagesBundles === null || imagesBundles === void 0 ? void 0 : imagesBundles.map(function(file, y) {
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Illustration["default"], {
                                                            src: file.url,
                                                            className: classnames_default()((styles_module_default()).imageBundle, (styles_module_default())["imageBundle-".concat(y + 1)]),
                                                            alt: file.alt
                                                        }, y);
                                                    })
                                                ]
                                            }, "cardText/".concat(i));
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (styles_module_default()).contentBlock,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentfulParser, {
                                                document: text
                                            })
                                        }, "cardText/".concat(index))
                                    }),
                                    link && /*#__PURE__*/ (0,jsx_runtime.jsx)(CallToAction, {
                                        data: link,
                                        handleOnClick: handleOnCTAClick,
                                        className: (styles_module_default()).link
                                    })
                                ]
                            }))
                        }, "card/".concat(index));
                    })
                }),
                !!linkAfterBlock && /*#__PURE__*/ (0,jsx_runtime.jsx)(Animated, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, constants/* REVEAL_ANIMATION_PROPS */.kt), {
                    transitionDelay: 50,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CallToAction, {
                        data: linkAfterBlock,
                        handleOnClick: handleOnCTAClick,
                        className: (styles_module_default()).callToAction
                    })
                }))
            ]
        })
    });
};
TabsSection.propTypes = {
    section: prop_types_default().instanceOf(Object).isRequired,
    type: (prop_types_default()).string.isRequired,
    handleOnCTAClick: (prop_types_default()).func.isRequired
};
/* harmony default export */ var sections_TabsSection = (TabsSection);


/***/ }),

/***/ 31890:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"image":"styles_image__T17hn"};

/***/ }),

/***/ 94481:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__ZX6yj","itemsContainer":"styles_itemsContainer__jN4TU","item":"styles_item__OsDHu","selected":"styles_selected__2_pEs","discovery-phase-services":"styles_discovery-phase-services__t6qfM","secondSectionView":"styles_secondSectionView__45rR1","penetration-testing":"styles_penetration-testing__wfaqo","company":"styles_company__Ree_c","ai-based-travel-planner":"styles_ai-based-travel-planner__VmXym","services":"styles_services__EtotH","firstSectionView":"styles_firstSectionView__uPrjj"};

/***/ }),

/***/ 14910:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"CardContainer_cardContainer__GnP7H","noBackground":"CardContainer_noBackground__jHEZf","sb_cardWithOverlay":"CardContainer_sb_cardWithOverlay__guDiR","overlay":"CardContainer_overlay__xSItN"};

/***/ }),

/***/ 69977:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"cardsWithFullWidthImage":"styles_cardsWithFullWidthImage__yM_r8","cards":"styles_cards__gkwCw","imageWrapper":"styles_imageWrapper__gKeB3","typeTitle":"styles_typeTitle__C_PEn","greySection":"styles_greySection__1sUMc","callToAction":"styles_callToAction__WJkAV","threeColumnsCards":"styles_threeColumnsCards__tyZOT","twoColumnsCards":"styles_twoColumnsCards__S2_M0","textContent":"styles_textContent___HSmI","container":"styles_container__k_vHh","section":"styles_section__ivtiX","tabs":"styles_tabs__XRhNj","tabTitle":"styles_tabTitle__3mx8c","tabTitleActive":"styles_tabTitleActive__aoQos","cardWrapper":"styles_cardWrapper__xE6AT","cardWrapperActive":"styles_cardWrapperActive__pF_ox","cardContainer":"styles_cardContainer__wwDVh","link":"styles_link__esPAF","cardContent":"styles_cardContent__kxzH1","contentBlock":"styles_contentBlock__CBuOB","discovery-phase-services":"styles_discovery-phase-services__k_6eY","firstSectionView":"styles_firstSectionView__oCeeJ","titleStyle":"styles_titleStyle__a0ns6","blockImage":"styles_blockImage__hhw3x","cardWrapper-1":"styles_cardWrapper-1__aKefg","cardWrapper-2":"styles_cardWrapper-2__bUMHL","cardWrapper-3":"styles_cardWrapper-3__TO2bO","cardWrapper-4":"styles_cardWrapper-4__kWcLB","cardWrapper-5":"styles_cardWrapper-5___62h9","cardWrapper-6":"styles_cardWrapper-6__pWs1M","blockPrototype":"styles_blockPrototype__ek2Av","imageBundle":"styles_imageBundle__9AJGO","secondSectionView":"styles_secondSectionView__PANZk","penetration-testing":"styles_penetration-testing__hdc7g","e-wallet-app-development":"styles_e-wallet-app-development__VtoKC","software-quality-assurance-services":"styles_software-quality-assurance-services__zlBqe","why-us":"styles_why-us__sH1V1","company":"styles_company__JsC7b","ai-based-travel-planner":"styles_ai-based-travel-planner__v2FKq","cardContent-1":"styles_cardContent-1__FB3kU","cardContent-2":"styles_cardContent-2___u2FG","services":"styles_services__sqdO6"};

/***/ }),

/***/ 30933:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 31304:
/***/ (function(module) {


;(function (name, root, factory) {
  if (true) {
    module.exports = factory()
    module.exports["default"] = factory()
  }
  /* istanbul ignore next */
  else {}
}('slugify', this, function () {
  var charMap = JSON.parse('{"$":"dollar","%":"percent","&":"and","<":"less",">":"greater","|":"or","¢":"cent","£":"pound","¤":"currency","¥":"yen","©":"(c)","ª":"a","®":"(r)","º":"o","À":"A","Á":"A","Â":"A","Ã":"A","Ä":"A","Å":"A","Æ":"AE","Ç":"C","È":"E","É":"E","Ê":"E","Ë":"E","Ì":"I","Í":"I","Î":"I","Ï":"I","Ð":"D","Ñ":"N","Ò":"O","Ó":"O","Ô":"O","Õ":"O","Ö":"O","Ø":"O","Ù":"U","Ú":"U","Û":"U","Ü":"U","Ý":"Y","Þ":"TH","ß":"ss","à":"a","á":"a","â":"a","ã":"a","ä":"a","å":"a","æ":"ae","ç":"c","è":"e","é":"e","ê":"e","ë":"e","ì":"i","í":"i","î":"i","ï":"i","ð":"d","ñ":"n","ò":"o","ó":"o","ô":"o","õ":"o","ö":"o","ø":"o","ù":"u","ú":"u","û":"u","ü":"u","ý":"y","þ":"th","ÿ":"y","Ā":"A","ā":"a","Ă":"A","ă":"a","Ą":"A","ą":"a","Ć":"C","ć":"c","Č":"C","č":"c","Ď":"D","ď":"d","Đ":"DJ","đ":"dj","Ē":"E","ē":"e","Ė":"E","ė":"e","Ę":"e","ę":"e","Ě":"E","ě":"e","Ğ":"G","ğ":"g","Ģ":"G","ģ":"g","Ĩ":"I","ĩ":"i","Ī":"i","ī":"i","Į":"I","į":"i","İ":"I","ı":"i","Ķ":"k","ķ":"k","Ļ":"L","ļ":"l","Ľ":"L","ľ":"l","Ł":"L","ł":"l","Ń":"N","ń":"n","Ņ":"N","ņ":"n","Ň":"N","ň":"n","Ō":"O","ō":"o","Ő":"O","ő":"o","Œ":"OE","œ":"oe","Ŕ":"R","ŕ":"r","Ř":"R","ř":"r","Ś":"S","ś":"s","Ş":"S","ş":"s","Š":"S","š":"s","Ţ":"T","ţ":"t","Ť":"T","ť":"t","Ũ":"U","ũ":"u","Ū":"u","ū":"u","Ů":"U","ů":"u","Ű":"U","ű":"u","Ų":"U","ų":"u","Ŵ":"W","ŵ":"w","Ŷ":"Y","ŷ":"y","Ÿ":"Y","Ź":"Z","ź":"z","Ż":"Z","ż":"z","Ž":"Z","ž":"z","Ə":"E","ƒ":"f","Ơ":"O","ơ":"o","Ư":"U","ư":"u","ǈ":"LJ","ǉ":"lj","ǋ":"NJ","ǌ":"nj","Ș":"S","ș":"s","Ț":"T","ț":"t","ə":"e","˚":"o","Ά":"A","Έ":"E","Ή":"H","Ί":"I","Ό":"O","Ύ":"Y","Ώ":"W","ΐ":"i","Α":"A","Β":"B","Γ":"G","Δ":"D","Ε":"E","Ζ":"Z","Η":"H","Θ":"8","Ι":"I","Κ":"K","Λ":"L","Μ":"M","Ν":"N","Ξ":"3","Ο":"O","Π":"P","Ρ":"R","Σ":"S","Τ":"T","Υ":"Y","Φ":"F","Χ":"X","Ψ":"PS","Ω":"W","Ϊ":"I","Ϋ":"Y","ά":"a","έ":"e","ή":"h","ί":"i","ΰ":"y","α":"a","β":"b","γ":"g","δ":"d","ε":"e","ζ":"z","η":"h","θ":"8","ι":"i","κ":"k","λ":"l","μ":"m","ν":"n","ξ":"3","ο":"o","π":"p","ρ":"r","ς":"s","σ":"s","τ":"t","υ":"y","φ":"f","χ":"x","ψ":"ps","ω":"w","ϊ":"i","ϋ":"y","ό":"o","ύ":"y","ώ":"w","Ё":"Yo","Ђ":"DJ","Є":"Ye","І":"I","Ї":"Yi","Ј":"J","Љ":"LJ","Њ":"NJ","Ћ":"C","Џ":"DZ","А":"A","Б":"B","В":"V","Г":"G","Д":"D","Е":"E","Ж":"Zh","З":"Z","И":"I","Й":"J","К":"K","Л":"L","М":"M","Н":"N","О":"O","П":"P","Р":"R","С":"S","Т":"T","У":"U","Ф":"F","Х":"H","Ц":"C","Ч":"Ch","Ш":"Sh","Щ":"Sh","Ъ":"U","Ы":"Y","Ь":"","Э":"E","Ю":"Yu","Я":"Ya","а":"a","б":"b","в":"v","г":"g","д":"d","е":"e","ж":"zh","з":"z","и":"i","й":"j","к":"k","л":"l","м":"m","н":"n","о":"o","п":"p","р":"r","с":"s","т":"t","у":"u","ф":"f","х":"h","ц":"c","ч":"ch","ш":"sh","щ":"sh","ъ":"u","ы":"y","ь":"","э":"e","ю":"yu","я":"ya","ё":"yo","ђ":"dj","є":"ye","і":"i","ї":"yi","ј":"j","љ":"lj","њ":"nj","ћ":"c","ѝ":"u","џ":"dz","Ґ":"G","ґ":"g","Ғ":"GH","ғ":"gh","Қ":"KH","қ":"kh","Ң":"NG","ң":"ng","Ү":"UE","ү":"ue","Ұ":"U","ұ":"u","Һ":"H","һ":"h","Ә":"AE","ә":"ae","Ө":"OE","ө":"oe","Ա":"A","Բ":"B","Գ":"G","Դ":"D","Ե":"E","Զ":"Z","Է":"E\'","Ը":"Y\'","Թ":"T\'","Ժ":"JH","Ի":"I","Լ":"L","Խ":"X","Ծ":"C\'","Կ":"K","Հ":"H","Ձ":"D\'","Ղ":"GH","Ճ":"TW","Մ":"M","Յ":"Y","Ն":"N","Շ":"SH","Չ":"CH","Պ":"P","Ջ":"J","Ռ":"R\'","Ս":"S","Վ":"V","Տ":"T","Ր":"R","Ց":"C","Փ":"P\'","Ք":"Q\'","Օ":"O\'\'","Ֆ":"F","և":"EV","ء":"a","آ":"aa","أ":"a","ؤ":"u","إ":"i","ئ":"e","ا":"a","ب":"b","ة":"h","ت":"t","ث":"th","ج":"j","ح":"h","خ":"kh","د":"d","ذ":"th","ر":"r","ز":"z","س":"s","ش":"sh","ص":"s","ض":"dh","ط":"t","ظ":"z","ع":"a","غ":"gh","ف":"f","ق":"q","ك":"k","ل":"l","م":"m","ن":"n","ه":"h","و":"w","ى":"a","ي":"y","ً":"an","ٌ":"on","ٍ":"en","َ":"a","ُ":"u","ِ":"e","ْ":"","٠":"0","١":"1","٢":"2","٣":"3","٤":"4","٥":"5","٦":"6","٧":"7","٨":"8","٩":"9","پ":"p","چ":"ch","ژ":"zh","ک":"k","گ":"g","ی":"y","۰":"0","۱":"1","۲":"2","۳":"3","۴":"4","۵":"5","۶":"6","۷":"7","۸":"8","۹":"9","฿":"baht","ა":"a","ბ":"b","გ":"g","დ":"d","ე":"e","ვ":"v","ზ":"z","თ":"t","ი":"i","კ":"k","ლ":"l","მ":"m","ნ":"n","ო":"o","პ":"p","ჟ":"zh","რ":"r","ს":"s","ტ":"t","უ":"u","ფ":"f","ქ":"k","ღ":"gh","ყ":"q","შ":"sh","ჩ":"ch","ც":"ts","ძ":"dz","წ":"ts","ჭ":"ch","ხ":"kh","ჯ":"j","ჰ":"h","Ṣ":"S","ṣ":"s","Ẁ":"W","ẁ":"w","Ẃ":"W","ẃ":"w","Ẅ":"W","ẅ":"w","ẞ":"SS","Ạ":"A","ạ":"a","Ả":"A","ả":"a","Ấ":"A","ấ":"a","Ầ":"A","ầ":"a","Ẩ":"A","ẩ":"a","Ẫ":"A","ẫ":"a","Ậ":"A","ậ":"a","Ắ":"A","ắ":"a","Ằ":"A","ằ":"a","Ẳ":"A","ẳ":"a","Ẵ":"A","ẵ":"a","Ặ":"A","ặ":"a","Ẹ":"E","ẹ":"e","Ẻ":"E","ẻ":"e","Ẽ":"E","ẽ":"e","Ế":"E","ế":"e","Ề":"E","ề":"e","Ể":"E","ể":"e","Ễ":"E","ễ":"e","Ệ":"E","ệ":"e","Ỉ":"I","ỉ":"i","Ị":"I","ị":"i","Ọ":"O","ọ":"o","Ỏ":"O","ỏ":"o","Ố":"O","ố":"o","Ồ":"O","ồ":"o","Ổ":"O","ổ":"o","Ỗ":"O","ỗ":"o","Ộ":"O","ộ":"o","Ớ":"O","ớ":"o","Ờ":"O","ờ":"o","Ở":"O","ở":"o","Ỡ":"O","ỡ":"o","Ợ":"O","ợ":"o","Ụ":"U","ụ":"u","Ủ":"U","ủ":"u","Ứ":"U","ứ":"u","Ừ":"U","ừ":"u","Ử":"U","ử":"u","Ữ":"U","ữ":"u","Ự":"U","ự":"u","Ỳ":"Y","ỳ":"y","Ỵ":"Y","ỵ":"y","Ỷ":"Y","ỷ":"y","Ỹ":"Y","ỹ":"y","–":"-","‘":"\'","’":"\'","“":"\\\"","”":"\\\"","„":"\\\"","†":"+","•":"*","…":"...","₠":"ecu","₢":"cruzeiro","₣":"french franc","₤":"lira","₥":"mill","₦":"naira","₧":"peseta","₨":"rupee","₩":"won","₪":"new shequel","₫":"dong","€":"euro","₭":"kip","₮":"tugrik","₯":"drachma","₰":"penny","₱":"peso","₲":"guarani","₳":"austral","₴":"hryvnia","₵":"cedi","₸":"kazakhstani tenge","₹":"indian rupee","₺":"turkish lira","₽":"russian ruble","₿":"bitcoin","℠":"sm","™":"tm","∂":"d","∆":"delta","∑":"sum","∞":"infinity","♥":"love","元":"yuan","円":"yen","﷼":"rial","ﻵ":"laa","ﻷ":"laa","ﻹ":"lai","ﻻ":"la"}')
  var locales = JSON.parse('{"bg":{"Й":"Y","Ц":"Ts","Щ":"Sht","Ъ":"A","Ь":"Y","й":"y","ц":"ts","щ":"sht","ъ":"a","ь":"y"},"de":{"Ä":"AE","ä":"ae","Ö":"OE","ö":"oe","Ü":"UE","ü":"ue","ß":"ss","%":"prozent","&":"und","|":"oder","∑":"summe","∞":"unendlich","♥":"liebe"},"es":{"%":"por ciento","&":"y","<":"menor que",">":"mayor que","|":"o","¢":"centavos","£":"libras","¤":"moneda","₣":"francos","∑":"suma","∞":"infinito","♥":"amor"},"fr":{"%":"pourcent","&":"et","<":"plus petit",">":"plus grand","|":"ou","¢":"centime","£":"livre","¤":"devise","₣":"franc","∑":"somme","∞":"infini","♥":"amour"},"pt":{"%":"porcento","&":"e","<":"menor",">":"maior","|":"ou","¢":"centavo","∑":"soma","£":"libra","∞":"infinito","♥":"amor"},"uk":{"И":"Y","и":"y","Й":"Y","й":"y","Ц":"Ts","ц":"ts","Х":"Kh","х":"kh","Щ":"Shch","щ":"shch","Г":"H","г":"h"},"vi":{"Đ":"D","đ":"d"},"da":{"Ø":"OE","ø":"oe","Å":"AA","å":"aa","%":"procent","&":"og","|":"eller","$":"dollar","<":"mindre end",">":"større end"},"nb":{"&":"og","Å":"AA","Æ":"AE","Ø":"OE","å":"aa","æ":"ae","ø":"oe"},"it":{"&":"e"},"nl":{"&":"en"},"sv":{"&":"och","Å":"AA","Ä":"AE","Ö":"OE","å":"aa","ä":"ae","ö":"oe"}}')

  function replace (string, options) {
    if (typeof string !== 'string') {
      throw new Error('slugify: string argument expected')
    }

    options = (typeof options === 'string')
      ? {replacement: options}
      : options || {}

    var locale = locales[options.locale] || {}

    var replacement = options.replacement === undefined ? '-' : options.replacement

    var trim = options.trim === undefined ? true : options.trim

    var slug = string.normalize().split('')
      // replace characters based on charMap
      .reduce(function (result, ch) {
        var appendChar = locale[ch];
        if (appendChar === undefined) appendChar = charMap[ch];
        if (appendChar === undefined) appendChar = ch;
        if (appendChar === replacement) appendChar = ' ';
        return result + appendChar
          // remove not allowed characters
          .replace(options.remove || /[^\w\s$*_+~.()'"!\-:@]+/g, '')
      }, '');

    if (options.strict) {
      slug = slug.replace(/[^A-Za-z0-9\s]/g, '');
    }

    if (trim) {
      slug = slug.trim()
    }

    // Replace spaces with replacement character, treating multiple consecutive
    // spaces as a single space.
    slug = slug.replace(/\s+/g, replacement);

    if (options.lower) {
      slug = slug.toLowerCase()
    }

    return slug
  }

  replace.extend = function (customMap) {
    Object.assign(charMap, customMap)
  }

  return replace
}))


/***/ })

}]);